import React from "react";
import { Badge } from "reactstrap";
import { Period } from "modules/Clinical/TimePoints/helpers/timpoints.types";
import { PeriodRow } from "./manualEntry.types";

export const isDeviationStatus = (statusStr?: string | null): boolean => {
  if (!statusStr) return false;
  const status = statusStr.trim().toLowerCase();
  return (
    status === "early" ||
    status === "exceeded tolerance" ||
    status === "exceed tolerance" ||
    status.includes("early") ||
    status.includes("exceed")
  );
};

export const deviationBadge = (deviation?: string | null) => {
  let color = "success";
  if (!deviation || deviation === "Pending") {
    color = "secondary";
  } else if (deviation === "No Deviation" || deviation === "0 min" || deviation === "0min") {
    color = "success";
  } else {
    color = "warning";
  }
  return (
    <Badge color={color} className="fw-medium px-2 py-1">
      {deviation || "Pending"}
    </Badge>
  );
};

export const calculateDeviation = (
  actualScheduledStr?: string | null,
  sampleCollectionStr?: string | null
): string => {
  if (
    !actualScheduledStr ||
    !sampleCollectionStr ||
    sampleCollectionStr === "--" ||
    actualScheduledStr === "--"
  ) {
    return "Pending";
  }

  const parseTimeToSeconds = (timeStr: string): number => {
    const parts = timeStr.split(":");
    const hrs = parseInt(parts[0], 10) || 0;
    const mins = parseInt(parts[1], 10) || 0;
    const secs = parseInt(parts[2], 10) || 0;
    return hrs * 3600 + mins * 60 + secs;
  };

  try {
    const schedSecs = parseTimeToSeconds(actualScheduledStr);
    const actualSecs = parseTimeToSeconds(sampleCollectionStr);
    const diffMins = Math.round((actualSecs - schedSecs) / 60);

    if (diffMins === 0) return "No Deviation";
    return `${diffMins > 0 ? "+" : ""}${diffMins} min`;
  } catch (e) {
    return "Pending";
  }
};

export const isVerified = (val: boolean | undefined | null): boolean => val === true;

export const buildTableRows = (period: Period): PeriodRow[] =>
  period.timepoints.map((tp, idx) => ({
    id: tp.timepoint_sort,
    srno: idx + 1,
    timepoint: tp.timepoint_number,
    scheduledTime: period.dose_time,
    actualTime: tp.actualdosetime,
    deviation: tp.deviation,
    deviationreason: tp.deviationreason,
    deviationstatus: tp.deviationstatus,
    dosingstation: tp.dosingstation,
    dosingscheduledate: tp.dosingscheduledate,
    samplecollectiontime: tp.samplecollectiontime,
    samplecollectionstatus: tp.samplecollectionstatus,
    samplecollectionid: tp.samplecollectionid,
    iscorrection: tp.iscorrection,
    iscorrectionverified: tp.iscorrectionverified,
    isverified: tp.isverified,
  }));

export const getFieldName = (tpNum: string) =>
  `tp_${String(tpNum).replace(/\./g, "_")}`;
